import clsx from 'clsx';
import React from 'react';

import { topic_landing_path } from '../../../routes';
import { Entity } from '../../../utils/backend-api/forumPosts';
import { encodeEntity } from '../../../utils/formatting';
import styles from './styles.module.scss';

export default function ForumTags({ tags, small }: { tags: Entity[]; small?: boolean }) {
  return (
    <div
      className={clsx(styles.tags, {
        [styles.smallTags]: small,
      })}
    >
      {tags.slice(0, 5).map((tag) => (
        <a
          href={topic_landing_path(encodeEntity(tag.label))}
          key={tag.value}
          className={styles.tag}
        >
          #{tag.label}
        </a>
      ))}
    </div>
  );
}
